// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"c3bcc41e","667":"a8ad7dfe","897":"e3ec611a","938":"49416a90","977":"638bda40"}[chunkId] + ".chunk.js";
};